import Cookies from '../modules/cookies';

const cookies = new Cookies();

// cookies.createCookie({ value: 1, name: 'loader', days: 7})